<script lang="ts">
  import Info from '$components/info.svelte';
  import { storyblokEditable } from '$lib/actions/storyblok-editable';
  import { cn } from '$lib/utils';
  import type { InfoStoryblok } from '$types/bloks';

  export let block: InfoStoryblok;
</script>

{#if block.title || block.text}
  <section
    class={cn(
      'px-4 lg:px-8',
      block.cta_link && block.cta_label
        ? 'pt-12 pb-0 lg:pt-[120px] lg:pb-14'
        : 'py-12 lg:py-[120px]'
    )}
  >
    <div class="w-full lg:max-w-[680px] isolate mx-auto" use:storyblokEditable={block}>
      <Info {block} />
    </div>
  </section>
{/if}
